/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum UsageTypeCategory {
    NationalNetworks = 'National Networks (Class A)',
    Cable = 'Cable',
    NationalCable = 'National Cable',
    SingleNetwork = 'National Cable Single Network',
    LocalCable = 'Local Cable',
    Wildspot = 'Wildspot',
    Dealer = 'Dealer',
    AllOtherNA = 'All Other North American Use',
    SpanishLanguageProgramUse = 'Spanish-Language Program Use',
    IONAndDiginet = 'ION & Diginet',
    ForeignUse = 'Foreign Use',
    TraditionalDigital = 'Traditional Digital',
    TraditionalDigitalWithYouTube = 'Traditional Digital w/YouTube',
    StreamingPlatforms = 'Streaming Platforms',
    SocialMedia = 'Social Media',
    YouTube = 'YouTube',
    OtherPlatforms = 'Gaming Platforms, VR/AR, Emerging Platforms',
    Print = 'Print Use',
    OOH = 'Out of Home Use',
    BTS = 'B-roll & Behind the Scenes Use',
    TheatricalIndustrial = 'Theatrical & Industrial Use',
    AFMSession = 'AFM Session (1 hour)',
    AFMFirstUse = 'AFM First Use',
    AFMForeign = 'AFM Foreign Use',
    AFMInternetRadio = 'AFM Internet Radio Spot',
    RadioNetwork = 'Radio Network',
    RadioWildspot = 'Radio Wildspot',
    InternetRadio = 'Internet Radio',
    RadioDealer = 'Radio Dealer',
}
